import { useState, useLayoutEffect, useReducer, useCallback } from "react"
import { countryReducer } from "./reducers"

const initState = {
    distributors_of_city: []
}

export const useGetCityDistributors = () => {
    const [state, dispatch] = useReducer(countryReducer, initState)

    const getDistributorsOfCity = useCallback(
        selectCity => {
            fetch(`/api/distributors-filter?filter=${selectCity}`)
                .then(res => {
                    if(res.ok) res.json().then(data => {
                        if(data.length === 0) return dispatch({ type: "getDistributorsOfCity", payload: { distributors_of_city: false }})
                        dispatch({ type: "getDistributorsOfCity", payload: { distributors_of_city: data }})
                    })
                })
        },
        [dispatch]
    )

    const getDistributorsAll = useCallback(
        () => {
            fetch(`/api/distributors-filter`)
                .then(res => {
                    if(res.ok) res.json().then(data => {
                        if(data.length === 0) return dispatch({ type: "getDistributorsOfCity", payload: { distributors_of_city: false }})
                        dispatch({ type: "getDistributorsOfCity", payload: { distributors_of_city: data }})
                    })
                })
        },
        [dispatch]
    )

    return { state, getDistributorsOfCity, getDistributorsAll }
}


export const useWindowWidth = () => {
    const windowWidth = window.innerWidth
    const [width, setWidth] = useState(windowWidth)

    useLayoutEffect(()=> {
        function updateWidth() {
            setWidth(window.innerWidth)
        }
        window.addEventListener('resize', updateWidth);
        window.addEventListener('load', updateWidth);
        updateWidth();
        return () => {
            window.removeEventListener('resize', updateWidth);
            window.removeEventListener('load', updateWidth);
        }
    })

    return width
}


// WEBPACK FOOTER //
// ./src/components/pages/projects/distributors/state/hooks.js